import {
   PtrnCampoEditableBase,
   PtrnCampoValidarResult,
   PtrnResultadoProcesarCampo,
   PtrnState,
   PtrnTiposCampo
} from '../../patronTypes';
import {
   PtrnProcesarCommonOpts,
   PtrnTransformarCampoFn,
   PtrnValidarCampoFn
} from './ptrnProcesarTypes';
import {ptrnValidarDate} from './ptrnProcesarDate';
import {ptrnValidarDatetime} from './ptrnProcesarDatetime';
import {ptrnValidarFloat, ptrnTranformarFloat} from './ptrnProcesarFloat';
import {ptrnValidarInt, ptrnTranformarInt} from './ptrnProcesarInt';
import {ptrnValidacionString, ptrnTranformarString} from './ptrnProcesarString';
import {ptrnValidacionTime} from './ptrnProcesarTime';
import {PtrnProcesarUtilsCfg} from './ptrnProcesarUtils';
import {ValidateState} from 'lib.common';
import {ptrnTranformarFormula} from './ptrnProcesarFormula';
import {PtrnPropsUtil} from '..';

type PtrnValidacionMapaBase = {
   [key: string]: PtrnValidarCampoFn;
};
type PtrnTransformacionMapaBase = {
   [key: string]: PtrnTransformarCampoFn;
};
export const ptrnTransformarCampo: PtrnTransformacionMapaBase = {
   [PtrnTiposCampo.string]: ptrnTranformarString,
   [PtrnTiposCampo.int]: ptrnTranformarInt,
   [PtrnTiposCampo.float]: ptrnTranformarFloat,
   [PtrnTiposCampo.formula]: ptrnTranformarFormula
};
export const ptrnValidarCampoOnChange: PtrnValidacionMapaBase = {
   [PtrnTiposCampo.string]: ptrnValidacionString,
   [PtrnTiposCampo.int]: ptrnValidarInt,
   [PtrnTiposCampo.float]: ptrnValidarFloat,
   [PtrnTiposCampo.date]: ptrnValidarDate,
   [PtrnTiposCampo.time]: ptrnValidacionTime,
   [PtrnTiposCampo.datetime]: ptrnValidarDatetime
};

export const ptrnValidarCampoOnBlur: PtrnValidacionMapaBase = {};

export default function ptrnProcesarCampo(
   value: any,
   campoConfig: PtrnCampoEditableBase,
   estadoLocal: PtrnState,
   estadoGlobal: any,
   opts: {
      aplicarOnBlur?: boolean;
   } & PtrnProcesarCommonOpts
): PtrnResultadoProcesarCampo {
   const cfg = PtrnProcesarUtilsCfg.getValidCfg(campoConfig, opts);

   let returnValue: PtrnResultadoProcesarCampo = {
      valorProcesado: {
         valor: value,
         errores: null,
         fueModificado: false
      },
      gravedadMaxima: ValidateState.SUCCESS
   };
   let fullValidarResult: PtrnCampoValidarResult = PtrnProcesarUtilsCfg.NoErrResult();
   let partialValidarResult: PtrnCampoValidarResult = PtrnProcesarUtilsCfg.NoErrResult();

   // 0. antes de empezar a validar el nuevo valor ejecutamos la funcion beforeValidate de la configuracion del tipo
   returnValue.valorProcesado.valor = PtrnProcesarUtilsCfg.execTransformarCfg(
      campoConfig.transformarAntesDeValidar,
      returnValue.valorProcesado.valor,
      estadoLocal
   );

   //#region validaciones
   // 1. Ejecutar las validaciones onChange definidas por el tipo de campo
   // >> ejecutamos siempre la validacion para limpiar posibles errores anteriores
   fullValidarResult = PtrnProcesarUtilsCfg.execValidarCampoFn(
      ptrnValidarCampoOnChange[campoConfig.tipo],
      value,
      cfg,
      estadoLocal
   );

   if (fullValidarResult.errores.length > 0) {
      returnValue.valorProcesado.errores = fullValidarResult.errores.map((curr) => curr.msg);
   }
   // >> si la gravedad maxima del resultado de la validacion en de tipo ERROR y no se requiere aplicar las validaciones onBlur, no debe permitir cambiar el valor del estado
   if (fullValidarResult.gravedadMaxima === ValidateState.ERROR && !opts.aplicarOnBlur) {
      returnValue.gravedadMaxima = fullValidarResult.gravedadMaxima;
      return returnValue;
   }

   // 2. Ejecutar las validaciones definidas por el usuario
   partialValidarResult = PtrnProcesarUtilsCfg.execValidarCfg(
      cfg.validarOnChange,
      returnValue.valorProcesado.valor,
      estadoLocal,
      estadoGlobal
   );

   if (partialValidarResult.errores.length > 0) {
      fullValidarResult.gravedadMaxima = PtrnProcesarUtilsCfg.getMaxGravedad(
         fullValidarResult.gravedadMaxima,
         partialValidarResult.gravedadMaxima
      );
      fullValidarResult.errores = [...fullValidarResult.errores, ...partialValidarResult.errores];
   }

   // 3. si se debe aplicar las validaciones onBlur se ejecutan
   if (opts.aplicarOnBlur) {
      // 3.0. Aplicamos validaciones por defecto de PtrnCampoBase
      const esObligatorio = PtrnPropsUtil.exeCondicionFn(
         campoConfig.esObligatorio,
         value,
         estadoLocal
      );
      let campoBaseValidacionResult: PtrnCampoValidarResult =
         esObligatorio && value == null
            ? {
                 errores: [
                    {
                       codeValidate: 'E422',
                       estado: ValidateState.ERROR,
                       msg: `El campo '${campoConfig.label || campoConfig.name}' es obligatorio.`
                    }
                 ],
                 gravedadMaxima: ValidateState.ERROR
              }
            : {
                 errores: null,
                 gravedadMaxima: ValidateState.SUCCESS
              };
      if (campoBaseValidacionResult.gravedadMaxima === ValidateState.ERROR) {
         returnValue.gravedadMaxima = campoBaseValidacionResult.gravedadMaxima;
         returnValue.valorProcesado.errores = campoBaseValidacionResult.errores.map(
            (curr) => curr.msg
         );
         return returnValue;
      }

      // 3.1. Ejecutar las validaciones onBlur por tipo de campo
      let onBlurResult = PtrnProcesarUtilsCfg.execValidarCampoFn(
         ptrnValidarCampoOnBlur[campoConfig.tipo],
         returnValue.valorProcesado.valor,
         cfg,
         estadoLocal
      );
      // 3.2. Ejecutar las validaciones definidas por el usuario
      partialValidarResult = PtrnProcesarUtilsCfg.execValidarCfg(
         cfg.validarOnBlur,
         returnValue.valorProcesado.valor,
         estadoLocal,
         estadoGlobal
      );
      if ((partialValidarResult.errores.length || onBlurResult.errores.length) > 0) {
         // (a) combinamos los arreglos de errores en case se decida q todo cambio debe provocar un cambio en el valor del estado
         fullValidarResult.gravedadMaxima = PtrnProcesarUtilsCfg.getMaxGravedad(
            fullValidarResult.gravedadMaxima,
            partialValidarResult.gravedadMaxima,
            onBlurResult.gravedadMaxima
         );
         fullValidarResult.errores = [
            ...fullValidarResult.errores,
            ...partialValidarResult.errores,
            ...onBlurResult.errores
         ];
      }
   }
   if (fullValidarResult.errores.length > 0) {
      returnValue.valorProcesado.errores = fullValidarResult.errores.map((curr) => curr.msg);
   }
   //#endregion

   // 4. Ejecutar las funciones de transformacion del nuevo valor
   returnValue.gravedadMaxima = fullValidarResult.gravedadMaxima;
   returnValue.valorProcesado.valor = PtrnProcesarUtilsCfg.execTransformarCampoFn(
      ptrnTransformarCampo[campoConfig.tipo],
      returnValue.valorProcesado.valor,
      cfg,
      estadoLocal
   );

   return returnValue;
}
